//import { DxListComponent, DxListModule } from 'devextreme-angular';
import { Component, inject, Input, OnInit, ViewChild, input, ChangeDetectionStrategy } from '@angular/core';

import { jkRestReturnClass, openWinClass } from '../../services/jkClass';
import { CR, jkRestReturn } from '../../services/jkInterface';
import { MatDivider } from '@angular/material/divider';
//import { DxTemplateModule } from 'devextreme-angular/core';
import { MaterialModule } from '../../material.module';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkLib } from '../../services/jkCommon';
import { JkCatchOpenWin } from '../../services/jkCatchOpenWin';


@Component({
    selector: 'app-jklist',
    templateUrl: './jklist.component.html',
    styleUrls: ['./jklist.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDivider,MaterialModule,
    ],
})
export class JklistComponent extends JkBaseComponent implements OnInit {
  jkOpenWin: JkCatchOpenWin = inject(JkCatchOpenWin);
  override comType: string = 'jklist';
  //@ViewChild(DxListComponent, { static: false })
  //list!: DxListComponent;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() itemList: any[] = [];
  readonly itemKey = input<string>('');
  readonly itemValue = input<string>('');
  readonly value = input<any[]>([]);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() height: number = 500;
  // @Input() width: number = 800;
  readonly isMultiSelect = input<boolean>(false);
  readonly keyExpr = input<string[]>([]);
  openwinIn: openWinClass;
  openwinOut: openWinClass;
  ret: jkRestReturn;
  params: any[] = [];
  expireDay: number = 0;
  searchExpr: string[] = [];
  readonly itemTemplate = input<string>('');//FIXME: not work
  readonly templateCallback = input.required<(item: any) => any>(); //FIXME: not work
  constructor() {
    super();
    this.width.set(Math.round(window.innerWidth * 0.9));
    this.height = Math.round(window.innerHeight * 0.9);
    //parent = this;
    this.openwinIn = new openWinClass();
    this.openwinOut = new openWinClass();
    this.ret = new jkRestReturnClass();

   }

  override ngOnInit() {
    super.ngOnInit();

  }
  onFocusedRowChanged?: (e: any) => void;

  async get(maintable: string, item: string, type: string) {
    // await this.openwinIn.getopenwin(maintable, item, type, this.ret);
    //this.openwinIn = await jkOpenWin.getopenwin(maintable, item, type, this.ret);
    this.openwinIn = await this.jkOpenWin.getopenwin(this.openwinIn, this.ret);
    this.cdr.markForCheck();
  }
  async openwin(openwinIn: openWinClass, params: any[],isMultiSelect: boolean = false,
    expireDay: number = 0) {
      //this.setMultiSelect(isMultiSelect);
    jkLib.cloneObject(params, this.params);
    this.expireDay = expireDay;
    jkLib.cloneObject(openwinIn, this.openwinIn);
    this.itemList = await this.jkOpenWin.doOpenWin2(params, expireDay, this.openwinIn, this.openwinOut);
    this.cdr.markForCheck();
    try {
      this.setColumnDisplay();
    } catch (error: any) {
      //this.columnLabel = {};
      console.error(error.message);
    }
  }
  async doRefresh() {
    let p:any[] = [];
    jkLib.cloneObject(this.params, p);
    await this.openwin(this.openwinIn, p,this.isMultiSelect(), this.expireDay);
  }
  async setColumnDisplay() {
    //this.visible = true;
    await this.get(this.openwinIn.mainTable, this.openwinIn.item, this.openwinIn.type);

    let labelList = this.openwinIn.display.split(CR);
  }
}
